import { type App } from '~/app';
import { isMobile } from '@root/src/framework/scripts/helpers/browser/media-query';

export default (app: App) => {
    app.logger.debug('[Stockland FE] Initialise Stockland Global Navigation Component');

    const listeners: Array<[Element | Window | Document, string, EventListenerOrEventListenerObject]> = [];

    app.afterMount
        .then(() => {
            mountGlobalNavigation(listeners);
        })
        .catch((error: Error) => {
            throw new Error('[Stockland FE] Unable to register Stockland Global Navigation Component', error);
        });

    return function destroyGlobalNavigation() {
        unMountGlobalNavigation(listeners);

        app.logger.debug('[DXA] Global Navigation Component destroyed');
    };
};

function mountGlobalNavigation(
    listeners: Array<[Element | Window | Document, string, EventListenerOrEventListenerObject]>,
    root: HTMLElement | null = null
) {
    let rootNode: Document | HTMLElement = document;
    if (root) rootNode = root;
    /* When the user scrolls down, hide the ribbon bar. When the user scrolls up, show the ribbon bar */
    let previousScrollpos = window.scrollY;
    const ribbonBarParent = rootNode.querySelector<HTMLElement>(".ribbon-bar-parent")
    const hubNav = rootNode.querySelector<HTMLElement>(".hub-navigation-bar")
    const enquiryButtonParent = rootNode.querySelector<HTMLElement>(".enquiry-button-parent") 
    window.addEventListener('scroll', function () {
        let ribbonBarParentHeight = 0;
        const currentScrollPos = window.scrollY;
        if (ribbonBarParent){
            ribbonBarParentHeight = ribbonBarParent.offsetHeight;
            ribbonBarParent.style.top = (previousScrollpos > currentScrollPos) ? "113px" : `${113 - ribbonBarParentHeight}px`
        }

        if (enquiryButtonParent) {
            enquiryButtonParent.style.top = (previousScrollpos > currentScrollPos) ? `${114 + ribbonBarParentHeight}px` : "114px"
        }
        
        previousScrollpos = currentScrollPos;
    })

    if (hubNav) {
        handleHubScroll(hubNav);
    }
}

export function unMountGlobalNavigation(
    listeners: Array<[Element | Window | Document, string, EventListenerOrEventListenerObject]>
) {
    for (const [element, event, listener] of listeners) {
        element.removeEventListener(event, listener);
    }
}
const handleHubScroll = (nav: HTMLElement) => {
    let previousScrollPos = window.scrollY;
    window.addEventListener('scroll', function () {
        if(!isMobile(1025)){
            let navHeight = 0;
            const currentScrollPos = window.scrollY;
            if (nav){
                navHeight = nav.offsetHeight +1;
                nav.style.top = (previousScrollPos > currentScrollPos) ? '0px' : '-'+navHeight+'px';
            }
            previousScrollPos = currentScrollPos;
        }
    });
    window.addEventListener('resize', function () {
        if(isMobile(1025)){
            nav.style.top = '0px';
        }
    });

};
